// utils
// import { suggestedNetwork } from '../../components/carousel/network/NetworkCarousel.mocks';
import Head from 'next/head';
import { useRouter } from 'next/router';
import { useState } from 'react';
import WhatsAppComponent from '../../components/fixed/whatsapp/WhatsappComponent';
import PopUpComponent from '../../components/popUp/PopUpComponent';
import { formatSelects, isColorLight } from '../../utils/FunctionsGlobals';
import { buildCanonical } from '../../utils/url';
// import NetworkPieces from '../../components/pieces/network/NetworkPieces';
import { motion } from 'framer-motion';
import dynamic from 'next/dynamic';
import { useAuth } from '../../components/context/Info';
import WelcomePiecesCompany from '../../components/pieces/welcomeCompany/WelcomePiecesCompany';
import { terms_default } from '../../configs/constants';
import { getDefaultServerSideProps } from '../../lib/server/site-props';
import styles from './Terms.module.css';
const AboutPieces = dynamic(() => import('../../components/pieces/about/AboutPieces'), { ssr: false });
const AboutPieces1 = dynamic(() => import('../../components/pieces/about1/AboutPieces1'), { ssr: false });
const AboutPieces2 = dynamic(() => import('../../components/pieces/about1/AboutPieces2'), { ssr: false });

export const getServerSideProps = getDefaultServerSideProps;

const Terms = () => {
    const router = useRouter();
    const {
        allDataHome,
        isMobile1,
        init_props,
        favorito
    } = useAuth();
    // useState
    const allCity = allDataHome?.cidades;
    const allCities = allCity ? formatSelects(allCity) : [];
    const site = allDataHome?.site;
    const routes = ['home', 'política'];
    const [activeDrawer, setActiveDrawer] = useState<any>(null);
    const termos = site?.termos_uso || "";
    const bannerListagem = allDataHome?.allBanners.filter((item: { titulo: string; }) => item.titulo === "listagem");
    const urlBannerListagem = bannerListagem ? bannerListagem.length > 0 ? bannerListagem[0] : null : null;
    const cor_texto = isColorLight(site?.cor5) ? site?.cor11 : site?.cor13;
    const codsite2 = init_props?.codsite;
    const origin = init_props?.prodOrigin;
    const canonicalUrl = buildCanonical(init_props?.prodOrigin || site?.site, router.asPath || '/termos');

     const renderRodape = () => {
        switch (site?.rodape) {
            case 1:
                return (
                    <motion.div
                        initial={{ opacity: 0, y: 40 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        transition={{ duration: 1, ease: [0.22, 1, 0.36, 1] }}
                        viewport={{ once: true, amount: 0.22 }}
                    >
                        <AboutPieces1 site={site} allCities={allCities} allCitiesTipes={allDataHome?.tipos} codsite={codsite2} origin={origin} isMobile={isMobile1} allRodape={allDataHome?.rodape} favorito={favorito}/>
                    </motion.div>
                );
            case 2:
                return (
                    <AboutPieces allRodape={allDataHome?.rodape} site={site} allCities={allCities} allCitiesTipes={allDataHome?.tipos} codsite={codsite2} origin={origin} isMobile={isMobile1}/>
                );
            case 3:
                return (
                    <AboutPieces2 site={site} allRodape={allDataHome?.rodape}/>
                );
            default:
            return (
                <motion.div
                    initial={{ opacity: 0, y: 40 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    transition={{ duration: 1, ease: [0.22, 1, 0.36, 1] }}
                    viewport={{ once: true, amount: 0.22 }}
                >
                    <AboutPieces1 site={site} allCities={allCities} allCitiesTipes={allDataHome?.tipos} codsite={codsite2} origin={origin} isMobile={isMobile1} allRodape={allDataHome?.rodape} favorito={favorito}/>
                </motion.div>
            );
        }
    }


    return (
        <div className={styles.container} style={{background: site?.cor5}}>
            <Head>
                <title>Termos</title>
                <meta name="robots" content="index, follow" />
                <meta property="og:url" content={canonicalUrl} />
                <link rel="canonical" href={canonicalUrl} key="canonical" />
            </Head>
            <WhatsAppComponent site={site} />
            <PopUpComponent />
            <WelcomePiecesCompany
                site={site}
                routes={routes}
                setActiveDrawer={setActiveDrawer}
                activeDrawer={activeDrawer}
                favorito={[]}
                bannerListagem={urlBannerListagem}
                props={allDataHome}
            />
            <label className={styles.subtitle} style={{color: cor_texto}}>TERMOS DE USO</label>
            <p className={styles.adjust_terms} style={{color: cor_texto}}>
                {termos || terms_default(site)}
            </p>
            { renderRodape() }

        </div>
    );
};

export default Terms;
